import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { StoredStateData } from 'src/app/driver/storage/models/stored-state-data';
import { UserStateService } from 'src/app/user-state/user-state.service';
import { StateDataRepositoryCacheManager } from '../../cache-manager/state-data-repository-cache-manager';

/**
 * Operation class that gets all of the list of dispatched services state data.
 */
@Injectable({
	providedIn: 'root'
})
export class GetAllStateDataOperation {
	/**
	 * @constructor
	 * @param stateDataRepositoryCacheManager Cache manager used to interact with the StateDataRepository.
	 * @param userStateService Service to access the current user's state.
	 */
	constructor(
		private readonly stateDataRepositoryCacheManager: StateDataRepositoryCacheManager,
		private readonly userStateService: UserStateService
	) { }

	/**
	 * Executes the operation to retrieve all state data.
	 * @returns Observable emitting an array of StoredStateData.
	 */
	public Execute$(): Observable<StoredStateData[]> {
		return this.stateDataRepositoryCacheManager.GetAll$().pipe(
			map((storedStateServices: StoredStateData[]) => {
				return storedStateServices.filter((serviceState: StoredStateData) => 
					serviceState.UserName == this.userStateService.State.Username
					&& serviceState.CrownId == this.userStateService.State.CrownIdentifier
				) ?? [];
		}));
	}
}
